import React from 'react';
import {
  BuildingOffice2Icon,
  TruckIcon,
  ExclamationTriangleIcon,
  ShieldCheckIcon,
  LockClosedIcon,
  DocumentCheckIcon,
  FingerPrintIcon,
  EyeIcon,
  ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';
import { IndustryPageTemplate } from '../../components/page-templates/MarketPageTemplates';

const challenges = [
  {
    icon: DocumentCheckIcon,
    title: 'Procurement & Compliance',
    description: 'Strict procurement regulations, tender requirements, and compliance frameworks governing every ICT purchase.',
  },
  {
    icon: LockClosedIcon,
    title: 'Data Security & Sovereignty',
    description: 'Sovereign data handling requirements and security classifications that dictate how equipment is managed.',
  },
  {
    icon: BuildingOffice2Icon,
    title: 'Multi-Site Deployments',
    description: 'Government facilities spread across regions and jurisdictions, each with distinct regulatory environments.',
  },
  {
    icon: ExclamationTriangleIcon,
    title: 'Accountability & Audit Trails',
    description: 'Every asset must be fully traceable from procurement through disposal with complete documentation.',
  },
];

const solutions = [
  {
    icon: ShieldCheckIcon,
    title: 'IOR/EOR with Full Regulatory Compliance',
    description: 'Import/export of record services meeting government procurement and trade compliance standards.',
  },
  {
    icon: FingerPrintIcon,
    title: 'Certified Data Destruction',
    description: 'NIST 800-88 and ADISA-certified data wiping and physical destruction with certificates of destruction.',
  },
  {
    icon: EyeIcon,
    title: 'Full Chain-of-Custody Tracking',
    description: 'End-to-end audit trail from receipt to delivery, with tamper-evident controls and documentation.',
  },
  {
    icon: LockClosedIcon,
    title: 'Secure Warehousing & Controlled Access',
    description: 'Access-restricted facilities with CCTV monitoring, inventory segregation, and security protocols.',
  },
  {
    icon: TruckIcon,
    title: 'White Glove Delivery with Documentation',
    description: 'Secure delivery with proof of delivery, sign-off procedures, and complete shipment records.',
  },
  {
    icon: ClipboardDocumentCheckIcon,
    title: 'Asset Lifecycle Reporting',
    description: 'Comprehensive reporting across the full asset lifecycle for audits, compliance reviews, and asset registers.',
  },
];

const stats = [
  { value: '140+', label: 'Countries' },
  { value: '6', label: 'Global Offices' },
  { value: '10+', label: 'Years Experience' },
  { value: '6,500+', label: 'Field Workers' },
];

const GovernmentPublicSector: React.FC = () => (
  <IndustryPageTemplate
    eyebrow="Government & Public Sector"
    title="ICT Logistics for Government & Public Sector"
    highlight="Government & Public Sector"
    description="Secure, compliant logistics for public sector organisations deploying and managing ICT assets across jurisdictions."
    heroIcon={ShieldCheckIcon}
    heroAccentIcon={BuildingOffice2Icon}
    challengesIntro="Government organisations face the highest standards for security, compliance, and accountability in ICT logistics."
    challenges={challenges}
    solutionsIntro="Execution controls designed for public sector security requirements, audit expectations, and multi-site accountability."
    solutions={solutions}
    useCase="From defence department hardware refreshes to public health ICT infrastructure, TrueLog delivers the security, compliance, and accountability that government operations require."
    stats={stats}
    ctaTitle="Ready to strengthen your public sector ICT logistics?"
    ctaDescription="Let TrueLog deliver the security, compliance, and accountability your government operations demand."
  />
);

export default GovernmentPublicSector;
